import React from "react";
import icons from "../icons";
import { Link } from 'react-router-dom';
import Footer from "../components/auth/Footer";
import SideRightContent from "../components/auth/SideRightContent";

export default function TwoStepVarification() {
  return (
    <div className="wrapper">
      <div className="sign-page">
        <div className="right-dot"></div>
        <div className="content">
          <div className="flex-warp-block single-input-block">
            <div className="container">
              <div className="logo hide">
                <Link to="/">
                <img src={icons.OPAL_LOGO} alt="Logo" />
              </Link>
              </div>
              <div className="sign-form">
                <div className="form-heading">
                  <h1>2 Step Verification</h1>
                  <p>
                    Please confirm your account by entering the authorization
                    code sent to your email
                  </p>
                </div>
                <form>
                  <p className="error hide" role="alert">
                    Invalid user name and/or password. Please try again
                  </p>
                  <div className="input-group">
                    <span className="input-group-text">
                      <img
                        src={icons.PASSWORD_ICON}
                        alt="Password Icon"
                        title="Password Icon"
                      />
                    </span>
                    <input
                      type="Password"
                      className="form-control"
                      placeholder="Password"
                      aria-required="true"
                    />
                  </div>
                  <div className="form-button">
                    <button type="submit" className="btn">
                      Verify & Login
                    </button>
                  </div>

                  <div className="resend-code">
                    <p>
                      It may take a minute to receive your code Haven’t received
                      it? <Link to="#">Resend Code</Link>
                    </p>
                  </div>
                </form>
              </div>

              <SideRightContent />
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
